// extracted by mini-css-extract-plugin
export var active = "_28-c";
export var activeIndicator = "_28-7";
export var animate = "_28-b";
export var contentWidthTabs = "_28-5";
export var disabled = "_28-d";
export var flat = "_28-1";
export var fullWidth = "_28-3";
export var lg = "_28-a";
export var md = "_28-9";
export var redoButtonTabGroup = "_28-0";
export var sm = "_28-8";
export var tabButton = "_28-4";
export var tabButtonsContainer = "_28-2";
export var xs = "_28-6";